/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import { Nullable } from "../../base-types";
import DirtyValueCalculator from "../../dirty-value-calculator";
import { PropertyDataType, PropertyValue, Type, TypeInfo } from "./data-type";
import { IProperty, PropertyBase } from "./property";

export interface ICultureInsensitiveProperty<
    T extends PropertyDataType | unknown = PropertyDataType,
    B extends boolean = boolean,
> extends IProperty {
    /**
     * Gets the value of the property.
     * @returns The value.
     */
    getValue(): PropertyValue<T, B>;

    /**
     * Sets the value of the property.
     * @param value - The value to set
     */
    setValue(value: PropertyValue<T, B>): void;
}

export class CultureInsensitiveProperty<T extends PropertyDataType | unknown, B extends boolean>
    extends PropertyBase<T, B>
    implements ICultureInsensitiveProperty<T, B>
{
    private _value: PropertyValue<T, B>; //TODO use PropertyValue?
    private _dirtyValueCalculator: DirtyValueCalculator;

    declare readonly isMultiLanguage: false;

    get isDirty(): boolean {
        if (!this.isTracking) {
            return false;
        }

        return this._dirtyValueCalculator.isDirty(this._value);
    }

    constructor(
        name: string,
        typeInfo: TypeInfo<T, B>,
        value?: B extends true ? Nullable<Array<Type<T>>> : Nullable<Type<T>>,
        hasDataSource: boolean = false
    ) {
        super(name, typeInfo, hasDataSource);

        this.isMultiLanguage = false;

        if (value !== undefined) {
            this._value = value; //TODO clone?
        }
    }

    getValue(): B extends true ? Nullable<Array<Type<T>>> : Nullable<Type<T>> {
        return this._value as B extends true ? Nullable<Array<Type<T>>> : Nullable<Type<T>>;
    }

    setValue(value: B extends true ? Nullable<Array<Type<T>>> : Nullable<Type<T>>): void {
        this._value = value; //TODO clone value?
    }

    getTypeName(): string {
        return this.constructor.name;
    }

    startTracking(): void {
        if (this.isTracking) {
            return;
        }

        this.isTracking = true;

        this._dirtyValueCalculator = new DirtyValueCalculator();
        this._dirtyValueCalculator.setOriginalValue(this._value);
    }

    markClean(): void {
        if (!this.isTracking) {
            return;
        }

        this._dirtyValueCalculator.setOriginalValue(this._value);
    }
}
